import component from './es-ES/component';
import globalHeader from './es-ES/globalHeader';
import menu from './es-ES/menu';
import pwa from './es-ES/pwa';
import common from './es-ES/common';
import form from './es-ES/form';
import supportChat from './es-ES/supportChat';
import notifications from './es-ES/notifications';
import processes from '../pages/Process/locales/es-ES';

export default {
  'navBar.lang': 'Lenguages',
  'layout.user.link.help': 'Ayuda',
  'layout.user.link.privacy': 'Privacidad',
  'layout.user.link.terms': 'Términos',
  'app.preview.down.block': 'Descarga esta página para tu proyecto local',
  'app.welcome.link.fetch-blocks': 'Obtén todos los bloques',
  'app.welcome.link.block-list':
    'Construye rápidamente páginas estándar basadas en el desarrollo de `bloque`',
  ...globalHeader,
  ...menu,
  ...pwa,
  ...component,
  ...common,
  ...form,
  ...supportChat,
  ...notifications,
  ...processes,
};
